export default __webpack_public_path__ + "static/media/cari.2338d467.png";